import { BasicTemplateComponent, LandingTemplateComponent, RightAsideTemplateComponent, StandardTemplateComponent } from 'vnext-widgets';

const templateMapping: Record<string, any> = {
  'basic': BasicTemplateComponent,
  'standard': StandardTemplateComponent,
  'landing': LandingTemplateComponent,
  'right-aside': RightAsideTemplateComponent
};

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class TemplateLookupService {
  static getTemplate(key: string): any {
    const template = templateMapping[key.toLowerCase()];
    if (!template) {
      console.log('Unable to find template with key: ' + key);
    }
    return template;
  }
}
